import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { LocaleCurrency } from 'types/Shared/Locale'
import { getUserPreferencesSelectedCurrency } from 'selectors/user/cookie'
import { getMeasurementUnit } from 'selectors/user/session'
import { MeasurementUnit } from 'types/User/Session'

const mapStateToProps = createStructuredSelector({
  selectedCurrency: getUserPreferencesSelectedCurrency,
  measurementUnit: getMeasurementUnit,
})

export type SelectedFacetConnectorProps = {
  selectedCurrency: LocaleCurrency
  measurementUnit: MeasurementUnit
}

export default connect(mapStateToProps)
